import axios from 'axios';
const API_URL = "https://ads-txt.in"
export const addData = async (data) => {
    return await axios.post(`${API_URL}/save-link`, data).then((res) => res.data);
}

export const getAppDetail = async (subDomain) => {
    return await axios.get(`${API_URL}/app-detail/${subDomain}`).then(res => res.data);
}